query ContractDetails($id: ID!) {
  contract(id: $id) {
    id
    organizationId
    organization {
      id
      title
    }
    title
    currency
    invoiceCurrency
    status
    dateFrom
    dateTo
    billingPeriodMonths
    paymentPeriodType
    paidPeriodDays
    note
    canceledAt
    items {
      type
      title
      amount {
        value
        currency
      }
    }
  }
  contractPayments(filter: { contractId: $id }, rowsPerPage: 100) {
    nodes {
      id
      periodFrom
      periodTo
      invoiceDate
      expiredAt
      paidAt
      status
      expired
      amount {
        value
        currency
      }
      invoice {
        number
        issuedAt
        sentAt
        sentTo
        previousNumbers {
          number
          issuedAt
          reason
        }
      }
    }
    count
  }
}
